"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Scriber;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function Scriber(props) {
    var svgProps = Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 78 18",
        width: "78",
        height: "18",
        fill: "currentColor"
    }, props);
    return /*#__PURE__*/ _react.createElement("svg", _extends({}, svgProps), /*#__PURE__*/ _react.createElement("path", {
        d: "M1.5539 17.2847C1.03565 17.2847 0.64075 17.5066 0.46857 17.9255H0V12.5476H0.666449C1.38172 14.8665 3.35537 16.6431 5.60057 16.6431C7.47571 16.6431 8.70924 15.5295 8.70924 14.003C8.70924 12.2272 7.47571 10.771 5.30418 9.39012L2.63667 7.71201C0.860901 6.59841 0.0710981 5.46767 0.0710981 3.86408C0.0710981 1.5692 2.29145 0.0401377 5.64683 0.0401377C7.2744 0.0401377 8.01452 0.434183 8.77948 0.434183C9.12213 0.434183 9.42109 0.311685 9.47077 0.015295H9.84083L11.3742 4.75154H10.6092C9.8691 2.65454 8.11817 1.39702 5.87298 1.39702C3.99784 1.39702 2.93734 2.08745 2.93734 3.22247C2.93734 3.96259 3.33224 4.62818 4.83646 5.54134L7.9477 7.41647C10.4841 8.94297 11.7168 10.6725 11.7168 13.0659C11.7168 16.0752 9.39795 18 5.94407 18C3.72457 18 2.51589 17.2847 1.5539 17.2847Z",
        fill: "#151A19"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M13.0259 11.4871C13.0259 7.61351 15.8382 5.04794 19.7606 5.04794C22.8941 5.04794 24.8429 6.60185 24.8429 8.30309C24.8429 9.04321 24.275 9.53748 23.5109 9.53748C21.0438 9.53748 22.2259 6.3303 19.7606 6.3303C17.6884 6.3303 16.1097 8.40246 16.1097 11.4863C16.1097 14.4707 17.7373 16.4692 20.2052 16.4692C22.2525 16.4692 23.7327 15.2109 24.2013 13.065H24.9166C24.7196 15.9775 22.4992 17.9246 19.3657 17.9246C15.5666 17.9255 13.0259 15.3599 13.0259 11.4871Z",
        fill: "#151A19"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M34.7847 6.89823C34.7847 7.83537 34.2707 8.50182 33.379 8.50182C32.4367 8.50182 32.1703 7.49015 31.4541 7.49015C30.4922 7.49015 29.8506 8.77508 29.8506 10.9689V15.509C29.8506 16.7673 30.2703 16.9892 31.4781 17.0389V17.6556H26.126V17.0389C26.5945 16.9892 27.0134 16.7673 27.0134 16.0024V7.93473C27.0134 7.2186 26.5945 7.12009 26.126 7.12009V6.50333L29.1104 5.07278H29.7058L29.8043 7.68803C30.3183 6.00992 31.4079 5.02309 32.8136 5.02309C33.9957 5.02309 34.7847 5.81289 34.7847 6.89823Z",
        fill: "#151A19"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M40.6561 17.038V17.6548H36.0449V17.038C36.5135 16.9883 36.9332 16.7665 36.9332 16.0015V7.93474C36.9332 7.21861 36.5135 7.1201 36.0449 7.1201V6.50333L39.1776 5.07278H39.7704V16.0015C39.7686 16.7665 40.1875 16.9883 40.6561 17.038ZM36.5118 2.07044C36.5118 1.70449 36.6203 1.34675 36.8236 1.04247C37.0269 0.738195 37.3159 0.501038 37.654 0.360994C37.9921 0.220949 38.3641 0.184308 38.7231 0.255702C39.082 0.327096 39.4117 0.503318 39.6704 0.762086C39.9292 1.02085 40.1054 1.35055 40.1768 1.70947C40.2482 2.06839 40.2116 2.44042 40.0715 2.77852C39.9315 3.11662 39.6943 3.40559 39.39 3.60891C39.0858 3.81222 38.728 3.92074 38.3621 3.92074C38.1184 3.92314 37.8767 3.87692 37.6512 3.78479C37.4256 3.69265 37.2207 3.55645 37.0484 3.38416C36.8761 3.21186 36.7399 3.00693 36.6477 2.78136C36.5556 2.55578 36.5094 2.3141 36.5118 2.07044Z",
        fill: "#151A19"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M55.0882 11.4871C55.0882 15.3599 52.6948 17.9255 49.0919 17.9255C47.4386 17.9255 46.0569 17.1854 45.3416 16.0015C44.4284 16.1728 43.7877 16.9635 43.5898 17.9255H42.776V2.87717C42.776 2.16104 42.3563 2.06199 41.8877 2.06199V1.44565L45.0212 0.0150814H45.6131V7.19462C46.2787 5.83774 47.735 5.04794 49.4859 5.04794C52.843 5.04794 55.0882 7.61351 55.0882 11.4871ZM52.0044 11.4871C52.0044 8.57464 50.6475 6.65153 48.6002 6.65153C46.8013 6.65153 45.6148 8.20543 45.6148 10.5243V12.7695C45.6148 14.941 46.7987 16.3964 48.6002 16.3964C50.6475 16.3956 52.0044 14.4253 52.0044 11.4871Z",
        fill: "#151A19"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M67.6701 13.2629H68.3854C68.2141 16.0512 65.9432 17.9255 62.7112 17.9255C58.9857 17.9255 56.5195 15.3556 56.5195 11.4871C56.5195 7.61865 59.0354 5.04794 62.8345 5.04794C66.2387 5.04794 68.5087 7.41648 68.5087 10.9937H59.6016V11.4871C59.6016 14.4964 61.2292 16.4949 63.6483 16.4949C65.6468 16.4949 67.1519 15.2862 67.6701 13.2629ZM59.7267 9.8587H65.3016C65.2279 7.73686 64.2411 6.33115 62.7857 6.33115C61.2558 6.33115 60.0959 7.68803 59.7267 9.8587V9.8587Z",
        fill: "#151A19"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M77.9955 6.89823C77.9955 7.83537 77.4772 8.50182 76.5889 8.50182C75.6518 8.50182 75.3802 7.49015 74.665 7.49015C73.703 7.49015 73.0614 8.77508 73.0614 10.9689V15.509C73.0614 16.7673 73.4803 16.9892 74.6889 17.0389V17.6556H69.3359V17.0389C69.8045 16.9892 70.2242 16.7673 70.2242 16.0024V7.93473C70.2242 7.2186 69.8045 7.12009 69.3359 7.12009V6.50333L72.3212 5.07278H72.9132L73.0117 7.68803C73.5256 6.00992 74.6153 5.02309 76.0218 5.02309C77.2057 5.02309 77.9955 5.81289 77.9955 6.89823Z",
        fill: "#151A19"
    }));
}

//# sourceMappingURL=Scriber.js.map